export class CreateCaracteristicaRequest {

    public descripcion : string="";
}